/* import __COLOCATED_TEMPLATE__ from './stage-list.hbs'; */
import Component from '@glimmer/component';
import CourseModel from 'codecrafters-frontend/models/course';

interface Signature {
  Args: {
    course: CourseModel;
  };
}

export default class CourseOverviewPageStageListItemComponent extends Component<Signature> {}
